export const MENU_ROUTE = '/menu/:id';
export const DISH_ROUTE = '/menu/:id/dish/:dishId';
